/**
 * Shopify's market assignment is IP-based and, once set for a session, is not
 * re-evaluated — so a visitor whose IP was misread once (common with Canadian
 * mobile carrier NAT ranges) has no built-in way to be told their currency may
 * be wrong. This checks an independent signal (the device's IANA timezone,
 * which comes from OS settings, not the network) and offers a dismissible
 * prompt to switch into the existing Canada/CAD localization market via
 * Shopify's own native localization form — it never invents its own
 * switching logic.
 */
(function () {
  var CANADA_TIMEZONES = [
    'America/Toronto', 'America/Vancouver', 'America/Winnipeg', 'America/Edmonton',
    'America/Halifax', 'America/St_Johns', 'America/Regina', 'America/Whitehorse',
    'America/Yellowknife', 'America/Iqaluit', 'America/Moncton', 'America/Glace_Bay',
    'America/Goose_Bay', 'America/Blanc-Sablon', 'America/Nipigon', 'America/Rainy_River',
    'America/Atikokan', 'America/Swift_Current', 'America/Creston', 'America/Dawson',
    'America/Dawson_Creek', 'America/Fort_Nelson', 'America/Cambridge_Bay', 'America/Inuvik',
    'America/Resolute', 'America/Rankin_Inlet', 'America/Pangnirtung', 'America/Thunder_Bay',
  ];

  var DISMISS_COOKIE = 'geo_currency_banner_dismissed';
  var DISMISS_DAYS = 30;

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function init() {
    var banner = document.getElementById('geo-currency-banner');
    if (!banner) return;

    if (getCookie(DISMISS_COOKIE)) return;
    if (banner.dataset.currentCountry === 'CA') return;

    var timezone;
    try {
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch (error) {
      return;
    }
    if (CANADA_TIMEZONES.indexOf(timezone) === -1) return;

    banner.hidden = false;

    var switchButton = banner.querySelector('.geo-currency-banner__switch');
    var dismissButton = banner.querySelector('.geo-currency-banner__dismiss');

    switchButton.addEventListener('click', function () {
      // Header/announcement-bar selectors are off by default, so fall back to the footer switcher's CA button.
      var canadaLink =
        document.querySelector('localization-form a[data-value="CA"]') ||
        document.querySelector('[data-bh-country-switch="CA"]');
      if (canadaLink) {
        setCookie(DISMISS_COOKIE, '1', DISMISS_DAYS);
        canadaLink.click();
      }
    });

    dismissButton.addEventListener('click', function () {
      setCookie(DISMISS_COOKIE, '1', DISMISS_DAYS);
      banner.hidden = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
